<template>
  <div>
    <!-- <button @click="showModal">Add</button>  -->
    <a-modal v-model="visible" @ok="handleOk" @cancel="CancelModal" wrap-class-name="my-special-modal" :centered="true" :bodyStyle="{ padding: 0 }" width="100%" height="100vh" :footer="null">
      <div class="container">
        <img class="logo-image" src="../../assets/images/sidelogo-addphy.png" rel="preload" alt="logo" />

        <div class="right-side">
          <!-- <img class="backimg" src="../../assets/images/addphy-back.png" alt="back" > -->
          <!-- <div v-if="page == 'first'" class="right-content">
            <h1>Add Physician</h1> 
            <h3>Fill in the physician details</h3>
                <div class="input-name name">
                    <label for="name">Physician Name</label>
                    <input type="text" id="name" placeholder="Enter name"  v-model.lazy="$v.bName.$model">  
                    <div class="error-container" v-if="$v.bName.$error">
                        <div class="error-item" v-if="!$v.bName.required">
                            Name is required
                        </div>  
                    </div>
                </div>  
                <div class="input-name number">
                    <label for="number">NPI Number</label>
                    <input type="text" id="number" placeholder="Enter NPI number"  v-model.lazy="$v.npiNumber.$model" :maxLength="10">
                    <div class="error-container" v-if="$v.npiNumber.$error">
                    <div class="error-item" v-if="!$v.npiNumber.required">
                        NPI Number is required
                         </div>
                      </div>
                </div>  
                <div class="link"> 
                    <h3><a>Where can I find the NPI Number?</a></h3>
                </div>
                <div>
                    <button @click="addProvider1"  class="next-btn">Next</button>
                </div> 
            </div>   -->
          <div v-if="page == 'first'" class="right-content-page2">
            <h1>Register as Advocate</h1>
            <h3 class="subtitle">Fill in the Advocate details</h3>
            <div class="address-input">
              <div class="City-input">
                <label for="displayname"
                  >First Name<span class="required">*</span>
                  <a-tooltip placement="topLeft" overlayClassName="ant-dovemed-tooltip">
                    <template slot="title">
                      <span> First name will be unique to all users. </span>
                    </template>
                    <!-- <i
                        class="fa fa-info-circle"
                        aria-hidden="true"
                        :style="`color:${currentCircle.color_code} !important`"
                      ></i> -->
                  </a-tooltip>
                </label>
                <input type="text" id="displayname" placeholder="Provide First Name" v-model.lazy="$v.formResponses.displayName.$model" />
                <div class="error-container" v-if="$v.formResponses.displayName.$error">
                  <div class="error-item" v-if="!$v.formResponses.displayName.required">First Name is required</div>
                  <div class="error-item" v-if="!$v.formResponses.displayName.minLength">Minimum length is 6</div>
                  <div class="error-item" v-if="!$v.formResponses.displayName.maxLength">Maxium length is 20</div>
                  <!-- <div
                      class="error-item"
                      v-if="!$v.formResponses.displayName.isUnique"
                    >
                      First name already taken
                    </div> -->
                  <div class="error-item" v-if="!$v.formResponses.displayName.isAplhaNum && $v.formResponses.displayName.required">Please enter a valid First name</div>
                </div>
              </div>
              <!-- <div class="link"> 
                    <h3><a>Where can I find the NPI Number?</a></h3>
                </div> -->
              <div class="City-input">
                <label for="displayname">Last Name<span class="required">*</span></label>
                <a-input type="text" id="displayname" placeholder="Provide Last Name" v-model.lazy="$v.formResponses.last_name.$model" />

                <div class="error-container" v-if="$v.formResponses.last_name.$error">
                  <div class="error-item" v-if="!$v.formResponses.last_name.required">Last name is required</div>
                  <div class="error-item" v-if="!$v.formResponses.last_name.minLength">Minimum length is 1</div>
                  <div class="error-item" v-if="!$v.formResponses.last_name.maxLength">Maxium length is 20</div>
                  <div class="error-item" v-if="!$v.formResponses.last_name.isAplhaNum && $v.formResponses.last_name.required">Please enter a valid last name</div>
                </div>
              </div>
            </div>
            <div class="myself">
              <input type="checkbox" class="check-box" :checked="myself" @change="toggleMyself" />
              <span>I Represent Myself</span>
            </div>
            <div class="address-input" v-if="!myself">
              <div class="City-input">
                <label for="organization" style="width: 250px">
                  Organization You Represent
                  <span class="required">*</span></label
                >
                <input
                  type="text"
                  id="organization"
                  :disabled="myself"
                  :style="{ background: myself ? '#f5f5f5' : '#FFFFFF' }"
                  placeholder="Provide Organization"
                  v-model.lazy="$v.formResponses.organization.$model"
                />
                <div class="error-container" v-if="!myself">
                  <div class="error-item" v-if="!$v.formResponses.organization.required">Organization is required</div>
                  <div class="error-item" v-if="!$v.formResponses.organization.maxLength">Maxium length is 25</div>
                </div>
              </div>
              <div class="City-input">
                <label for="designation"> Designation <span class="required">*</span></label>
                <input
                  type="text"
                  id="designation"
                  :disabled="myself"
                  :style="{ background: myself ? '#f5f5f5' : '#FFFFFF' }"
                  placeholder="Provide Designation"
                  v-model.lazy="$v.formResponses.designation.$model"
                />
                <div class="error-container" v-if="!myself">
                  <div class="error-item" v-if="!$v.formResponses.designation.required">Designation is required</div>
                </div>
              </div>
            </div>

            <div class="address-input name">
              <div class="City-input">
                <label for="city">City <span class="required">*</span></label>
                <div class="search-input position-relative">
                  <font-awesome-icon size="1x" :icon="['fal', 'search']" class="position-absolute search-icon" />
                  <a-select
                    show-search
                    class="city-input input"
                    placeholder="Search City"
                    style="width: 278.5px"
                    :default-active-first-option="false"
                    :show-arrow="false"
                    :defaultValue="formResponses.city && formResponses.country ? formResponses.city + ',' + formResponses.country : undefined"
                    :filter-option="false"
                    id="city"
                    @search="val => getLocations(val)"
                    @select="val => selectLocation(val)"
                  >
                    <a-select-option v-for="c in locationsList" :key="JSON.stringify(c)">{{ c.city }}, {{ c.state }} </a-select-option>
                  </a-select>
                </div>

                <div class="error-container" v-if="$v.formResponses.city.$error">
                  <div class="error-item" v-if="!$v.formResponses.city.required">City is required</div>
                </div>
              </div>
              <div class="City-input">
                <label for="zipcode">Zipcode</label>
                <!-- <input type="text" id="zipcode" placeholder="Search Zipcode"  v-model="$v.postalCode.$model"    :disabled="city ? false : true" > -->

                <a-select
                  class="input"
                  :min="0"
                  placeholder="Zipcode"
                  v-model="$v.formResponses.zip_code.$model"
                  :defaultValue="formResponses.zipcode"
                  :disabled="formResponses.city ? false : true"
                  style="width: 278.5px"
                >
                  <a-select-option v-for="zipcode in zipCodeArray" :key="zipcode">
                    {{ zipcode }}
                  </a-select-option>
                </a-select>

                <div class="error-container" v-if="$v.formResponses.zip_code.$error">
                  <div class="error-item" v-if="!$v.formResponses.zip_code.required">Zipcode is required</div>
                </div>
              </div>
            </div>

            <div class="address-input name">
              <div class="City-input">
                <label for="birthday" style="width: 250px"> Birthday (year,month)<span class="required">*</span></label>
                <font-awesome-icon icon="fa-thin fa-magnifying-glass" />
                <a-month-picker
                  style="width: 278.5px"
                  class="city-input input"
                  placeholder="Year and Month only"
                  :disabledDate="disabledDate"
                  :defaultValue="formResponses.birthDate"
                  @change="handleBirthDateChange"
                />
                <div class="error-container" v-if="$v.formResponses.birthDate.$error">
                  <div class="error-item" v-if="!$v.formResponses.birthDate.required">DOB is required</div>
                </div>
              </div>
              <div class="City-input">
                <label for="gender">Gender</label>
                <!-- <input type="text" id="zipcode" placeholder="Search Zipcode"  v-model="$v.postalCode.$model"    :disabled="city ? false : true" > -->

                <a-select class="city-input input" :min="0" :size="'large'" defaultValue="male" placeholder="Select gender" v-model="$v.formResponses.gender.$model" style="width: 278.5px">
                  <a-select-option value="male">Male</a-select-option>
                  <a-select-option value="female">Female</a-select-option>
                  <a-select-option value="other">Other</a-select-option>
                </a-select>

                <div class="error-container" v-if="$v.formResponses.gender.$error">
                  <div class="error-item" v-if="!$v.formResponses.gender.required">Gender is required</div>
                </div>
              </div>
            </div>

            <div class="terms-conditions">
              <input type="checkbox" class="check-box" :checked="termsCondition" @change="toggleTermsConditions" />
              <span
                >I Agree to<span class="tandc" @click="handleTermsAndCondtions()"><a>Terms and Conditions</a></span> of DoveMed</span
              >
            </div>

            <!-- <div class="options ">
                    <div class="option1">
                        <input type="radio" id="option1" name="age" value="1">
                        <label for="option1">Just suggesting a physician</label>
                    </div>
                    <div class="option2">
                        <input type="radio" id="option2" name="age" value="2">
                        <label for="option2">I am the physician</label>
                    </div> 
                </div> -->

            <div>
              <a-button
                @click.prevent="handleSubmit"
                :disabled="!termsCondition"
                :loading="loading"
                :style="{
                  background: !termsCondition ? '#E2E8F0' : '',
                }"
                class="next-btn"
                >Submit</a-button
              >
            </div>
          </div>
          <!-- <div v-if="page == 'second'" class="right-content-submit"> 
                <div>
                    <img class="submit-mark" src="../../assets/images/addphy-submit.png" alt="submit-rightmark">
                </div> 
                <div class="submit-message">
                    <h3><strong> Thank you for</strong></h3>
                    <h3><strong>Suggesting a Advocate!</strong></h3>
                </div>
                <div class="sub-message">
                    <p>DoveMed will review this Advocate and inform you once it's being listed on Mycircles.</p>
                </div>
                <div>
                    <button @click="handleOk" class="submit-btn">Continue</button>
                </div>
            </div>        -->
        </div>
      </div>
    </a-modal>
    <EmailVerifyModal ref="emailVerifyModal" />
  </div>
</template>

<script>
import { required, requiredIf, minLength, maxLength, email } from "vuelidate/lib/validators"
import { RepositoryFactory } from "../../repositories/RepositoryFactory"
import { mapGetters } from "vuex"
import EmailVerifyModal from "../Modals/EmailVerification"
import Repository from "../../repositories/Repository"

const AppRepository = RepositoryFactory.get("app")
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "AddAdvocateModal",
  computed: {
    ...mapGetters({
      currentCircle: "Circle/currentCircle",
    }),
  },
  components: {
    EmailVerifyModal,
  },
  data() {
    return {
      month: ["Jan", "Feb", "Mar", "April", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"],
      page: "first",
      circle_id: "",
      visible: false,
      authenticated: false,
      uiState: "submit_not_clicked",
      loading: false,
      empty: true,
      errors: false,
      country: [],
      state: [],
      dataOfmonth: null,
      locationsList: [],
      zipCodeArray: [],
      formResponses: {
        displayName: null,
        displayNameResponse: null,
        last_name: null,
        password: null,
        email: null,
        birthDate: null,
        organization: null,
        designation: null,
        gender: null,
        role: "advocate",
        address_line1: null,
        address_line2: null,
        city: null,
        state: null,
        country: null,
        zip_code: null,
      },
      myself: true,
      termsCondition: false,
    }
  },
  validations: {
    formResponses: {
      displayName: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(20),

        // isUnique(value) {
        //    standalone validator ideally should not assume a field is required
        //   if (value === "") return true;

        //    simulate async call, fail for all logins with even length
        //   return new Promise((resolve, reject) => {
        //     const url = `${process.env.BASE_API_URL}/displaynamecheck/?key=${this.formResponses.displayName}`;
        //     this.$http
        //       .get(url)
        //       .then(result => {
        //         if (result.status === 200) {
        //           this.formResponses.displayNameResponse = result.data;
        //         }
        //         resolve(result.data.status === 200);
        //       })
        //       .catch(err => reject(err));
        //   });
        // },
        isAplhaNum() {
          const regex = /[a-zA-Z]/
          const doesItHaveLetter = regex.test(this.formResponses.displayName)
          return doesItHaveLetter ? true : false
        },
      },
      last_name: {
        minLength: minLength(6),
        maxLength: maxLength(20),
        required,
        isAplhaNum() {
          const regex = /[a-zA-Z]/
          const doesItHaveLetter = regex.test(this.formResponses.last_name)
          return doesItHaveLetter ? true : false
        },
      },
      password: {
        //  minLength: minLength(1),
        required: requiredIf(function() {
          return !this.authUser
        }),
        //   strongPassword(password1) {
        //   return (
        //     /[a-z]/.test(password1) && //checks for a-z
        //     /[0-9]/.test(password1) && //checks for 0-9
        //     /\W|_/.test(password1) && //checks for special char
        //     password1.length >= 8
        //   )
        // }
      },
      email: {
        // required,
        // email
      },
      organization: {
        maxLength: maxLength(25),
        // required: requiredIf(function() {
        //   return !this.myself;
        // })
        required,
      },
      designation: {
        // required: requiredIf(function() {
        //   return !this.myself;
        // })
        required,
      },
      birthDate: {
        required,
      },
      city: {
        required,
      },
      gender: {
        // required
      },
      role: {
        required,
      },
      state: {
        // required
      },
      country: {
        // required
      },
      zip_code: {
        // required
      },
    },
  },

  created() {
    console.warn("AddAdvocateModal.vue is created")
    this.formResponses.role = "advocate"
    this.fillDataIfAuthorized()
    this.getLocations("a")
  },

  methods: {
    disabledDate(current) {
      return (
        current &&
        current >
          this.moment()
            .endOf("day")
            .subtract(18, "years")
      )
    },
    showModal(circle_id) {
      // console.log("inside advocate", circle_id)
      this.circle_id = circle_id
      this.visible = !this.visible
    },
    CancelModal() {
      // console.log(this.formResponses)
      this.page = "first"
      this.formResponses.displayName = null
      this.formResponses.displayNameResponse = null
      this.formResponses.last_name = null
      this.formResponses.password = null
      this.formResponses.email = null
      this.formResponses.birthDate = null
      this.formResponses.organization = null
      this.formResponses.designation = null
      this.formResponses.gender = null
      this.formResponses.address_line1 = null
      this.formResponses.address_line2 = null
      this.formResponses.city = null
      this.formResponses.state = null
      this.formResponses.country = null
      this.formResponses.zip_code = null
      this.myself = true
      this.$v.$reset()
      // console.log(this.$v.$anyError)
      this.visible = false
    },
    handleOk() {
      this.page = "first"
      this.visible = false
    },
    setpage(pageno) {
      this.page = pageno
    },
    getLocations(city) {
      AppRepository.getLocations(city)
        .then(res => {
          this.locationsList = res.data.data && res.data.data.data
        })
        .catch(err => null)
    },

    getAllCountries() {
      AppRepository.getAllCountries()
        .then(res => {
          this.country = res.data.data
        })
        .catch(err => null)
    },

    selectLocation(val) {
      const value = JSON.parse(val)
      this.formResponses.city = value.city
      this.formResponses.state = value.state
      this.formResponses.country = value.country
      this.zipCodeArray = [...value.city_zipcodes]
    },
    getAllStates() {
      AppRepository.getAllStates()
        .then(res => {
          this.state = res.data.data
        })
        .catch(err => null)
    },
    fillDataIfAuthorized() {
      if (this.authUser) {
        this.authenticated = true
        const user = this.authUser.user
        // console.log(user, "adovasjdk");
        this.formResponses.email = user.email
        this.formResponses.birthDate = user.dob ? this.moment(user.dob).format("YYYY-MM-DD") : null
        this.formResponses.gender = user.gender
        if (user.location && user.location.length > 0) {
          this.formResponses.city = user.location[0].city ? user.location[0].city : undefined
          this.formResponses.state = user.location[0].state
          this.formResponses.country = user.location[0].country ? user.location[0].country : undefined
          this.formResponses.zip_code = user.location[0].zip_code
        }
      } else {
        this.formResponses.email = undefined
        this.formResponses.password = undefined
      }
    },
    handleTags(value) {
      this.formResponses.additionalConditions = value
      this.$v.formResponses.additionalConditions.$touch()
    },
    handleDiagnosisDateChange(date, dateString) {
      this.formResponses.diagnosisDate = dateString
      this.$v.formResponses.diagnosisDate.$touch()
    },
    handleBirthDateChange(date, dateString) {
      console.log(date, dateString)
      this.formResponses.birthDate = dateString + "-01"
      console.log(this.formResponses.birthDate)
      this.$v.formResponses.birthDate.$touch()
    },
    handleSubmit() {
      // this.formResponses.birthDate = `${this.dataOfmonth._i}/01`;
      console.log("handle-submit", this.formResponses, this.formResponses.displayName, this.formResponses.last_name)
      this.empty = !this.$v.formResponses.$anyDirty
      this.errors = this.$v.formResponses.$anyError
      this.uiState = "submit_clicked"
      console.log(this.$v.formResponses.$anyError, this.errors, this.myself, "validation Check")
      //  this.myself ? (this.errors = false) : this.errors;
      console.log(this.formResponses.displayName, this.formResponses.last_name)
      if (
        this.$v.formResponses.$anyError === false &&
        this.empty === false &&
        this.formResponses.displayName != null &&
        this.formResponses.displayName != " " &&
        this.formResponses.last_name != null &&
        this.formResponses.last_name != " " &&
        this.formResponses.birthDate != null &&
        this.formResponses.city != null
      ) {
        console.log(" validation check passed")
        const currentCircle = JSON.parse(localStorage.getItem("currentCircle"))
        const payload = {
          email: this.formResponses.email,
          password: this.formResponses.password,
          first_name: this.formResponses.displayName.toLowerCase(),
          middle_name: "",
          last_name: this.formResponses.last_name.toLowerCase(),
          display_name: this.formResponses.displayName.toLowerCase() + " " + this.formResponses.last_name.toLowerCase(),
          role: this.formResponses.role,
          gender: this.formResponses.gender,
          dob: this.moment(this.formResponses.birthDate).format("YYYY-MM-DD"),
          advocate: {
            designation: this.formResponses.designation,
            represent_organization: this.formResponses.organization,
          },
          user_circle: {
            circle: this.circle_id,
          },
          location: {
            address_line1: this.formResponses.address_line1,
            address_line2: this.formResponses.address_line2,
            city: this.formResponses.city,
            state: this.formResponses.state,
            country: this.formResponses.country,
            zip_code: this.formResponses.zip_code,
          },
        }

        console.log("in", payload)
        this.loading = true
        this.$store
          .dispatch("Signup/createUser", { payload })
          .then(data => {
            this.uiState = "form_submitted"
            // this.$router.push({ name: 'Home' })
            const user = JSON.parse(localStorage.getItem("user"))
            Repository.defaults.headers.common["Authorization"] = `Bearer ${user.user.token}`
            this.loading = false
            this.$v.$reset()
            // this.setpage('second');
            this.$router.push({ path: `/${this.currentCircle.condition_type}/home/activity` })
          })
          .catch(error => {
            this.loading = false
            this.$notification.error({
              message: "Error",
              description: error,
            })
          })
      } else {
        this.loading = false
        this.uiState = "validation_failed"
        console.log("validation failed")
        this.$v.$touch()
      }
    },
    toggleMyself(e) {
      this.myself = e.target.checked
    },
    toggleTermsConditions(e) {
      this.termsCondition = e.target.checked
    },
    handleTermsAndCondtions() {
      window.open(`${process.env.SSO_BASE_URL}/help-center/faq/mycircles-terms-of-use`)
    },
  },
}
</script>
<style lang="scss" scoped>
// .my-special-modal{

//     .ant-modal{
//         .ant-modal-content{
//             .ant-modal-body{
//                 .container{
//                     .right-side{
//                         .right-content-page2{
//                             .address-input{
//                                 .City-input{
//                                     .ant-select{
//                                         .ant-select-selection--single{
//                                             height: 56px;
//                                         }
//                                         .ant-select-selection__placeholder {
//                                             margin-top:0px ;
//                                         }
//                                     }
//                                 }
//                             }
//                         }
//                     }
//                 }
//             }
//         }
//     }
// }

@media screen and (max-height: 1024px) {
  .container {
    height: 100% !important;
  }
  .logo-image {
    height: 100vh !important;
  }
}

@media screen and (max-width: 1255px) {
  .right-side {
    margin-left: 50px !important;
  }
}

@media screen and (max-width: 1110px) {
  .logo-image {
    width: 390px;
  }
  .right-side {
    margin-left: 24px !important;
  }
}

@media screen and (max-width: 944px) {
  .logo-image {
    width: 154px;
  }
  .right-side {
    margin-left: 5px !important;
  }
}

@media screen and (max-width: 769px) {
  .logo-image {
    width: 350px !important;
  }
  .input-name > input {
    width: 278.5px !important;
  }
  .address-input {
    flex-direction: column !important;
    gap: 24px;
    height: 100% !important;
  }
  .next-btn {
    width: 278.5px !important;
    margin-bottom: 24px !important;
  }
  .link a {
    margin-left: 0px !important;
  }
  .right-content-page2 {
    padding: 10px !important;
    margin-left: 29px;
  }

  .right-content-submit {
    align-items: flex-start !important;
  }

  .submit-mark {
    margin-left: 145px;
  }

  .submit-message {
    width: 380px !important;
  }
  .sub-message {
    width: 350px !important;
  }
  .submit-btn {
    // margin-left: 125px;
    margin-top: 30px !important;
  }
}

@media screen and (max-width: 426px) {
  .logo-image {
    display: none;
    height: 100%;
  }
  .subtitle {
    margin-bottom: 48px !important;
  }

  .address-input {
    flex-direction: column !important;
    gap: 24px;
    margin-bottom: 24px;
    height: 100% !important;
  }
  .myself {
    margin-top: 24px;
  }

  .right-content-page2 {
    margin-top: 24px !important;
    margin-left: 0px !important;
  }

  .next-btn {
    width: 278.5px !important;
  }
  .container {
    justify-content: center;
  }
}

// @media screen and (max-width: 426px) and (min-width: 321px) {
//   .City-input input {
//     width: 327px !important;
//   }

//   .next-btn {
//     width: 327px !important;
//   }
// }

.search-input {
  display: flex;
  align-items: center;
  position: relative;
}
.search-icon {
  left: 5px;
  font-size: 20px;
  color: #94a3b8;
  z-index: 1;
  margin-left: 12px;
}

.container {
  display: flex;
  flex-direction: row;
  flex: 1;
  padding-left: 0px;
  height: 100vh;
  margin-left: 0px;
}
//  .modalwrap {
//     background-color: red;
//         .ant-modal {
//         width: 1444px !important;
//         transform-origin: 0%;
//         }
// }

.terms-conditions {
  margin-top: 27px;
}
.terms-conditions span {
  padding-left: 5px;
}
.terms-conditions a {
  color: #2a71d4 !important;
}
.terms-conditions input {
  cursor: pointer;
}
.next-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  width: 581px;
  height: 48px;
  background: #2a71d4;
  border-radius: 6px;
  margin-top: 24px;
  text-align: center;
  text-transform: capitalize;
  color: #ffffff !important;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  border: none;
}
.next-btn span {
  color: #ffffff !important ;
}
.logo-image {
  margin-left: 0px;
  height: 100vh;
}
.input-name {
  display: flex;
  flex-direction: column;
}
.number {
  padding-top: 31px;
}
.name {
  padding-top: 24px;
}
.input-name label {
  color: #647490;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  height: 24px;
  margin-bottom: 4px;
  text-align: start;
}

.input-name input {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 12px 16px;
  width: 581px;
  height: 56px;
}
.input-name input:focus {
  outline: none !important;
}
.backimg {
  margin-left: 917px;
  margin-top: 30.23px;
  margin-right: 29.77px;
}
.link a {
  color: #2a71d4 !important;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  text-align: right;
  width: 581px;
  height: 21px;
  align-self: stretch;
  margin-left: 368px;
}
.link {
  margin-top: 16px;
}
.right-side {
  padding: 0;
  margin-left: 189px;
}
.right-content {
  padding: 0;
  margin-top: 117.5px;
}
.right-content h1 {
  color: #0f1734;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  margin-bottom: 0;
}
.right-content h3 {
  color: #647490;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 24px;
}

.right-content-page2 {
  padding: 0px;
  margin-top: 56px;
}

.right-content-page2 h1 {
  color: #0f1734;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  margin-bottom: 0;
}

.right-content-page2 h3 {
  color: #647490;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
}

.address-input {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  width: 278.5px;
  height: 84px;
  margin-top: 24px;
}

.City-input {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;
  margin-right: 24px;
}

.City-input label {
  color: #647490;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  height: 24px;
  margin-bottom: 4px;
  text-align: start;
}

.City-input input {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 12px 16px;
  width: 278.5px;
  height: 56px;
}
.City-input input:focus {
  outline: none;
}

.options {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 10px;
  margin-top: 24px;
  width: 581px;
  height: 58px;
}
.options label {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
}

.options input {
  border: 2px solid #94a3b8;
  box-sizing: border-box;
}

.option1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 581px;
  height: 21px;
}
.option2 {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 581px;
  height: 21px;
  margin-top: 6px;
}

.right-content-submit {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 134px;
  // margin-right: 190px;
}

.submit-mark {
  width: 66.67px;
  height: 66.67px;
}
.submit-message {
  // height: 84px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  text-align: center;
  color: #0f1734;
  margin-top: 29px;
}
.sub-message {
  width: 581px;
  // height: 48px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #647490;
  margin-top: 8px;
}

.submit-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  width: 106px;
  height: 48px;
  background: #2a71d4 !important;
  border-radius: 6px;
  margin-top: 24px;
  border: none;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  text-transform: capitalize;
  color: #ffffff;
}
.submit-message h3 {
  margin-bottom: 0;
}

.right-content-exist {
  display: flex;
  flex-direction: column;
  padding: 0px;
  margin-top: 118px;
  position: absolute;
}

.exists-title {
  width: 581px;
  height: 84px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734 !important;
  text-align: start;
  margin-bottom: 8px;

  h3 {
    margin-bottom: 0;
  }
}
.exits-message {
  width: 581px;
  height: 48px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #647490 !important;
  text-align: start;
  margin-top: 8px;

  p {
    margin-top: 8px;
  }
}
.master-card {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 24px;
  width: 581px;
  height: 178px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-top: 24px;
}
.submit-btns {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  width: 587px;
  height: 144px;
  background: #ffffff;
  border-radius: 8px;
}

.view-profile {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  width: 587px;
  height: 48px;
  background: #2a71d4;
  border-radius: 6px;
  text-align: center;
  border: none;
  text-align: center;
  text-transform: capitalize;
  color: #ffffff !important;
  margin-top: 24px;
}
.npi-number {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  width: 587px;
  height: 48px;
  background: #e2e8f0;
  border-radius: 6px;
  border: none;
  text-align: center;
  text-transform: capitalize;
}
.profile-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  width: 93px;
  height: 126px;

  img {
    height: 70px;
    width: 70px;
    left: 0px;
    top: 0px;
    border-radius: 50%;
    border: 1px solid #f8fafd;
  }
}

.divider {
  height: 176px;
  border: 1px solid #cbd5e1 !important;
  margin-left: 24px;
  margin-top: -25px;
}
.details-card {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  width: 392px;
  height: 111px;
}
.nameofphy {
  height: 30px;
  width: max-content;
}
.nameofphy h5 {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  margin: 24px 24px 17px 24px;
  align-items: start;
  display: flex;
}
.medicine {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 8px;
  width: 112px;
  height: fit-content;
  background: #e1eaf7;
  border-radius: 4px;
  margin: 17px 96px 85px 24px;
}
.medicine p {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #2a71d4;
  margin-bottom: 0;
}
.card-number {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  width: 126px;
  height: 24px;
  p {
    margin-bottom: 0;
    margin-left: 0.03px;
    color: #0f1734 !important;
  }
}
.card-location {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  width: 152px;
  height: 42px;
  margin-top: 13.5px;
}

.location-complete {
  height: 42px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #94a3b8;
}

.location-complete p {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #94a3b8;
  margin-bottom: 0;
  align-items: start;
  display: flex;
  margin-left: 8.5px;
}
.card-distance {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px 0px 0px 28px;
  height: 21px;
  margin-top: 12px;
  display: flex;
  align-items: start;
}
.star-rating {
  width: 140.53px;
  height: 16px;
  margin-top: 4px;
  margin-bottom: 5px;
  li {
    margin: 0 1px 0 0;
  }
}
.ant-rate-star {
  margin: 0 1px 0 0;
}

.rating {
  margin-top: 5px;
  p {
    margin-bottom: 0;
  }
}
.required {
  color: tomato !important;
}
.myself {
  margin-top: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/AddAdvocateModal.vue